import React, { useState } from "react";
import { connect, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import {
  loadingToggleAction,
  loginAction,
} from "../../store/actions/AuthActions";

import logo from "../../images/logo.png";
import logotext from "../../images/Group 626086.svg";
import { login, saveTokenInLocalStorage } from "../../services/AuthService";
import Select from "react-select";
import { toast } from "react-toastify";
import ForgetPassword from "../modal/ForgetPassword";

function Login(props) {
  const [email, setEmail] = useState("");
  let errorsObj = { email: "", password: "", userType: "" };
  const [errors, setErrors] = useState(errorsObj);
  const [password, setPassword] = useState("");
  const [apiError, setApiError] = useState();
  const [isForgerPasswords, setIsForgerPasswords] = useState(false);

  const [selectedOption, setSelectedOption] = useState("");

  const options = [
    { value: "master", label: "Super Admin" },
    { value: "admin", label: "Admin" },
  ];
  const handleSelectChange = (selectedOption) => {
    setSelectedOption(selectedOption);
  };

  function onLogin(e) {
    e.preventDefault();
    let error = false;
    const errorObj = { ...errorsObj };
    if (email === "") {
      errorObj.email = "Email is Required";
      error = true;
    }
    if (password === "") {
      errorObj.password = "Password is Required";
      error = true;
    }
    // if (selectedOption === "") {
    //   errorObj.userType = "User Type is Required";
    //   error = true;
    // }
    // if (password.length < 6) {
    //   errorObj.password = "Password length must be at least 6 characters long!";
    //   error = true;
    // }
    if (password.length > 15) {
      errorObj.password =
        "Password length must be less than or equal to 15 characters long!";
      error = true;
    }
    setErrors(errorObj);
    if (error) {
      return;
    }

    login(email, password)
      .then((response) => {
        saveTokenInLocalStorage(response.data.result.token);
        console.log(response, "login reponse");
        props.history.push("/");
      })
      .catch((error) => {
        console.error(error.response, "Login error");
        setApiError(error.response.data.responseMessage);
      });
  }

  return (
    <div className="login-form-bx">
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-6 col-md-7 box-skew d-flex">
            <div className="authincation-content">
              <div className="mb-4">
                <h3 className="mb-1 font-w600">Welcome to Hotelly</h3>
                <p className="">Sign in by entering information below</p>
              </div>
              {apiError && (
                <div
                  role="alert"
                  className="fade alert-dismissible fade show alert alert-danger show"
                >
                  {apiError}
                </div>
              )}

              <form onSubmit={onLogin}>
                {/* <div className="form-group">
                  <label className="mb-2 ">
                    <strong> Select User Type </strong>
                  </label>
                  <Select
                    value={selectedOption}
                    onChange={handleSelectChange}
                    options={options}
                    isRequired={true}
                    isSearchable={false}
                  />
                  {errors.userType && (
                    <div className="text-danger fs-12">{errors.userType}</div>
                  )}
                </div> */}
                <div className="form-group">
                  <label className="mb-2 ">
                    <strong className="">Email</strong>
                  </label>
                  <input
                    type="email"
                    className="form-control"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  {errors.email && (
                    <div className="text-danger fs-12">{errors.email}</div>
                  )}
                </div>
                <div className="form-group">
                  <label className="mb-2 ">
                    <strong className="">Password</strong>
                  </label>
                  <input
                    type="password"
                    className="form-control"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    minLength={6}
                    maxLength={15}
                  />
                  {errors.password && (
                    <div className="text-danger fs-12">{errors.password}</div>
                  )}
                </div>
                <div className="text-right">
                  <button
                    type="submit"
                    // onClick={onLogin}
                    className="btn btn-primary btn-block mb-2"
                  >
                    Sign In
                  </button>
                  <strong
                    style={{ cursor: "pointer" }}
                    onClick={() => setIsForgerPasswords(true)}
                  >
                    Forget Password?
                  </strong>
                </div>
              </form>
            </div>
          </div>
          <div className="col-lg-6 col-md-5 d-flex box-skew1">
            <div className="align-self-center login-logo-div">
              <h1 className="login-h">HOTELLY</h1>
            </div>
          </div>
        </div>
      </div>
      {isForgerPasswords && (
        <ForgetPassword
          show={isForgerPasswords}
          onHide={() => setIsForgerPasswords(false)}
        />
      )}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    errorMessage: state.auth.errorMessage,
    successMessage: state.auth.successMessage,
    showLoading: state.auth.showLoading,
  };
};
export default connect(mapStateToProps)(Login);
